// extracted by mini-css-extract-plugin
export default {"root":"root","disabled__link":"disabled__link","centered-flex-row":"centered-flex-row","width-100":"width-100"};